// appcenter schema defined in buildschema
// appCenter is passed from the app -
export default (appCenterSchema, AppCenter) => {
  // When the App first runs, this required files can have appCenterSchema as a function
  if (!appCenterSchema || typeof appCenterSchema === 'function') {
    return [];
  }

  const { appCategories = [], appTools = [] } = appCenterSchema;

  const result = [];
  const categoryResult = [];
  // Key here: routes are ordered specific -> less specific
  // So that for instance /<category>/<tool> goes to Tool BUT
  // /<category> correctly defaults to Category

  appCategories.forEach(category => {
    const { location } = category;
    // add details routes to results first
    category.sections.forEach(section => {
      section.items.forEach(item => {
        const tool = appTools.find(tool => tool.name === item);
        // IMPORTANT if there is no match here tests will break
        // this compares a tool from the category section to the tool's name
        tool &&
          result.push({
            path: `appcenter/${category.location}/${tool.location}`,
            component: AppCenter,
            strict: true, // can remove once trailing slash bug is fixed
            exact: true
          });
      });
    });

    // save the category route for this category
    categoryResult.push({
      path: `appcenter/${location}`,
      component: AppCenter,
      exact: true
    });
  });

  // add all categories to result after all details are added
  result.push(...categoryResult);
  return result;
};
